import { render, staticRenderFns } from "./sitemap_xml.vue?vue&type=template&id=03c0a682"
import script from "./sitemap_xml.vue?vue&type=script&lang=js"
export * from "./sitemap_xml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports